import React, { useEffect, useState } from "react";
import { Typography, Button, Box, useMediaQuery } from "@mui/material";
import { useSelector } from "react-redux";


const ShowMoreLessText = ({ text, maxLength = 250,isShowMore,setIsShowMore,style={}}) => {
 const{languageWords}=useSelector((store)=>store?.addGuest)
 const isSmallScreen=useMediaQuery("sm")

  return (
    <Box>
    <Box
      sx={{
        fontSize: !isSmallScreen ? "1.2rem" : '0.9rem',
        mt: 1,
        wordBreak: "break-word",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "normal",
        mb: 2,
        
        ...style
      }}
    >
      {isShowMore ? text : `${text.slice(0, maxLength)}`}
      {text.length > maxLength && (
        <Box>
        <Typography
          onClick={(event)=>{
            event.stopPropagation();
            setIsShowMore()}}
          sx={{ ml: 1, textTransform: "none", fontSize: "1.1rem",textDecoration:"underline",mt:1 }}
        >
          {isShowMore ? languageWords?.Showless || 'showless':languageWords?.Showmore || 'showmore'}
        </Typography>
        </Box>
      )}
    </Box>
    </Box>
  );
};

export default ShowMoreLessText;
